<template>
  <div>
    <template v-if="to_examine_form.audit_status == 1">
      <div style="text-align: center;margin-top: 20px">
        <img style="height: 80px" src="../assets/icon_status1.png" alt="">
      </div>
      <div class="statusBox status1">
        <div class="statusBox_text">
          <div>{{ to_examine_form.review_text1 }}</div>
        </div>
      </div>
    </template>
    <template v-if="to_examine_form.audit_status == 2">
      <div style="text-align: center;margin-top: 20px">
        <img style="height: 80px" src="../assets/icon_status2.png" alt="">
      </div>
      <div class="statusBox status2">
        <div class="statusBox_text">
          <div>{{ to_examine_form.review_text2 }}</div>
        </div>
      </div>
    </template>
    <template v-if="to_examine_form.audit_status == 3">
      <div style="text-align: center;margin-top: 20px">
        <img style="height: 80px" src="../assets/icon_status3.png" alt="">
      </div>
      <div class="statusBox status3">
        <div class="statusBox_text">
          <div>{{ to_examine_form.review_text3 }}</div>
        </div>
      </div>
    </template>
    <div class="footer" style="margin-top: 100px;">
<!--      <button-->
<!--          class="btn"-->
<!--          @click="revoke">{{-->
<!--          to_examine_form.audit_status == 1 ? '撤销申请,重新提交' : to_examine_form.audit_status == 2 ? '查看详情' : '完善资料,重新提交'-->
<!--        }}-->
<!--      </button>-->
      <button

          class="btn"
          @click="revoke">{{
         '查看详情'
        }}
      </button>
      <button
          v-if="to_examine_form.audit_status == 2 "
          class=" btn_"
          @click="to_next">{{
         '下一步'
        }}
      </button>
    </div>

  </div>
</template>

<script>
import {personal, enterprise} from "@/utils/individualForm"; //动态表单切换
import {
  MemberBrandLists,
  MemberLevel_lists,
  Members_promiseUp,
  MembersDetail,
  MembersEdit,
  MembersRevoke,
  MembersSubmit
} from "@/api/api";

export default {
  components: {},
  props: ['to_examine_form'],
  name: "toExamine",
  data() {
    return {};
  },
  mounted() {
  },
  created() {

  },
  watch: {},
  methods: {

    revoke() {
      this.$parent.change_contentShow()
    },

    to_next() {
      this.$parent.to_next()
    },

  }
}
</script>

<style lang="scss" scoped>


/deep/ .el-dialog__body {
  //height: 600px !important;
  overflow: auto;
}


.statusBox {
  width: 749px;
  height: 100px;
  background: rgba(250, 173, 20, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.statusBox_text {
  width: 520px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.status1 {
  background: rgba(250, 173, 20, 0.1);
  color: #FAAD14;
}

.status2 {
  background: rgba(82, 196, 26, 0.1);
  color: #52C41A;
}

.status3 {
  background: rgba(255, 77, 79, 0.1);
  color: #FF0000;
}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eee;
}

/deep/ .el-tabs__header {
  //padding: 20px 0;
  margin: 0;
}

.content {
  padding-bottom: 40px;

  .main-title {
    margin-top: 40px;
    margin-bottom: 35px;
  }
}

/deep/ .el-dialog__footer {
  text-align: center;
}

</style>
